import { useEffect, useState } from 'react';

const INITIAL_RENDER_COUNT = 20;
const BATCH_SIZE = 30;

export function useProgressiveRender<T>(items: T[], isOpen: boolean): T[] {
  const [renderCount, setRenderCount] = useState(INITIAL_RENDER_COUNT);

  useEffect(() => {
    if (!isOpen) {
      setRenderCount(INITIAL_RENDER_COUNT);
      return;
    }

    if (renderCount >= items.length) return;

    const timer = requestAnimationFrame(() => {
      setRenderCount((prev) => Math.min(prev + BATCH_SIZE, items.length));
    });

    return () => cancelAnimationFrame(timer);
  }, [isOpen, renderCount, items.length]);

  if (!isOpen) return [];
  return items.slice(0, renderCount);
}
